export default {
      id: "contingency-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#contingency",
      toString: function () {
        return this.url;
      }
    }